import styled from 'styled-components';

const HeaderStyle = styled.header`
	--headerPadding: var(--sp5x);
	--gapDistance1: var(--sp5x);
	--gapDistance2: var(--sp8x);
	--gapDistance3: var(--sp2-5x);

	transform: translateY(-100%);
	transition: transform var(--trTime) ease-out 0.15s;
	position: fixed;
	top: 0;
	z-index: 1000;
	width: 100%;
	height: var(--headerHeight);

	&.active {
		transform: translateY(0);
	}

	.inner-wrapper-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: var(--headerPadding) var(--contPaddingLR);
		background-color: var(--white);
	}

	.navigation-container {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.inner-navigation-link {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
			gap: var(--gapDistance2);
		}

		.link-navigation {
			&.active {
				pointer-events: none;

				.link-navigation-text {
					text-decoration: underline;
				}
			}
		}
	}

	.wrapper-contact-language {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: var(--gapDistance1);
	}

	.phone {
		display: flex;
		align-items: center;
		gap: var(--gapDistance3);

		.phone-icon-wrapper {
			height: fit-content;

			.icon-container {
				--iconSize: var(--p2);
			}

			animation: 3000ms ease 0s normal none 1 running shake;
			animation-iteration-count: infinite;
		}

		.phone-text {
			white-space: nowrap;
		}

		.phone-icon {
			svg {
				transition: var(--trTime) ease-out;
			}
		}
	}

	.wrapper-menu-button {
		display: none;
	}

	.burger-info-block {
		display: none;
	}

	@keyframes shake {
		0% {
			transform: rotateZ(0deg);
		}
		5% {
			transform: rotateZ(-15deg);
		}
		10% {
			transform: rotateZ(15deg);
		}
		15% {
			transform: rotateZ(-10deg);
		}
		20% {
			transform: rotateZ(10deg);
		}
		25% {
			transform: rotateZ(-7deg);
		}
		30% {
			transform: rotateZ(7deg);
		}
		35% {
			transform: rotateZ(-5deg);
		}
		40% {
			transform: rotateZ(5deg);
		}
		45% {
			transform: rotateZ(-2deg);
		}
		50% {
			transform: rotateZ(0deg);
		}
		100% {
			transform: rotateZ(0deg);
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.phone {
				&:hover {
					.phone-text,
					svg,
					.icon-wrap {
						color: var(--hoverPrimaryColor);
					}
				}
			}

			.link-navigation {
				.link-navigation-text {
					&:hover {
						color: var(--hoverPrimaryColor);
					}
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--headerPadding: var(--sp3-5x);
		--gapDistance1: var(--sp3x);
		--gapDistance2: var(--sp6x);
		--gapDistance3: var(--sp1-5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--headerPadding: var(--sp3x);
		--gapDistance1: var(--sp3x);
		--gapDistance2: var(--sp5x);
		--gapDistance3: var(--sp1-5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--gapDistance1: var(--sp2x);
		--gapDistance2: var(--sp5x);
		--gapDistance3: var(--sp1x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--gapDistance1: var(--sp2x);
		--gapDistance2: var(--sp4x);
		--gapDistance3: var(--sp1x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--gapDistance1: var(--sp1x);
		--gapDistance2: var(--sp1x);
		--gapDistance3: var(--sp0-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--gapDistance1: var(--sp2-5x);
		--gapDistance2: var(--sp1-5x);

		.wrapper-menu-button {
			display: block;
			position: relative;
			z-index: 1;
		}

		.wrapper-contact {
			display: none;
		}

		.navigation-container {
			height: calc(100dvh - 100%);
			position: absolute;
			top: 100%;
			left: 0;
			transform: translateX(100%);
			background-color: var(--backgroundSecondaryColor);

			&.burger-container {
				flex-direction: column;
				padding: 0 var(--contPaddingLR);
				transition: var(--trTime) ease-in-out;

				.burger-info-block {
					display: block;
				}

				.inner-navigation-link {
					flex-direction: column;

					.link-navigation-text {
						color: var(--textSecondaryColor);
					}
				}

				.wrapper-contact {
					margin-top: var(--sp2x);
				}

				.phone-text {
					color: var(--textSecondaryColor);
				}

				.phone .phone-icon svg {
					fill: var(--textSecondaryColor);
				}

				.svg-block {
					display: flex;
					justify-content: center;
					align-items: center;
					gap: var(--gapDistance2);
					margin-top: var(--gapDistance2);

					.icon-container {
						--iconSize: var(--sp3x);
					}
				}

				.data-block {
					display: flex;
					align-items: center;
					flex-direction: column;
					gap: var(--sp1x);
					margin-top: var(--gapDistance2);
				}

				.line {
					border-top: 1px solid var(--textSecondaryColor);
					margin-top: var(--sp3x);
					padding-top: var(--sp3x);
				}
			}

			&.active {
				transform: translateX(0px);
			}
		}
	}
`;

export default HeaderStyle;
